// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fk63WX9DMEsdBtHsCt26{margin-top:4px}.isYx7EPxGighTHO8klKc{align-items:center;gap:4px;margin-top:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `Fk63WX9DMEsdBtHsCt26`,
	"warning": `isYx7EPxGighTHO8klKc`
};
export default ___CSS_LOADER_EXPORT___;
